var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOpenInNew(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.80523 11.2667C1.50512 11.2667 1.25145 11.1631 1.04423 10.9559C0.837009 10.7487 0.733398 10.495 0.733398 10.1949V1.80523C0.733398 1.50512 0.837009 1.25145 1.04423 1.04423C1.25145 0.83701 1.50512 0.733398 1.80523 0.733398H5.74356V1.60007H1.80523C1.7539 1.60007 1.7069 1.62145 1.66423 1.66423C1.62145 1.7069 1.60007 1.7539 1.60007 1.80523V10.1949C1.60007 10.2462 1.62145 10.2932 1.66423 10.3359C1.7069 10.3787 1.7539 10.4001 1.80523 10.4001H10.1949C10.2462 10.4001 10.2932 10.3787 10.3359 10.3359C10.3787 10.2932 10.4001 10.2462 10.4001 10.1949V6.25657H11.2667V10.1949C11.2667 10.495 11.1631 10.7487 10.9559 10.9559C10.7487 11.1631 10.495 11.2667 10.1949 11.2667H1.80523ZM4.4629 8.1564L3.84373 7.53723L9.7809 1.60007H7.60007V0.733398H11.2667V4.40006H10.4001V2.21923L4.4629 8.1564Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenInNew);
export default __webpack_public_path__ + "static/media/openInNew.98a99dd6.svg";
export { ForwardRef as ReactComponent };